<section class="wb-popup-small" id="popup-small-delete" style="display: block;">

  <div class="grid-x align-center word-wrap">
    <div class="cell shrink align-self-middle">
      <div class="content">

        <ul>
          <li>
            <h3>Rate Table Calculator ("RTC") Disclaimer</h3>
            <p> {{  this.disclaimerText }}</p>
          </li>
          <li>
         
            <button *ngIf="!this.dataService.isFromBrokerMobileApp()" class="button grey quoteLitebtn" (click)="navigrationBack()"
              routerLinkActive="router-link-active">Cancel</button>
              <button class="button" (click)="navigateByUrl()" routerLinkActive="router-link-active">Accept</button>
          </li>

        </ul>

      </div>
    </div>
  </div>

</section>